<h3>District Roles</h3>
<p>
  Roles allow a school district to enable what a school district is able to do.
</p>

<div class="d-flex">
  <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-pills col-2" orientation="vertical">
    <ng-container *ngFor="let role of roles">
      <li [ngbNavItem]="role.id">
        <a ngbNavLink>{{ role.name }}</a>
        <ng-template ngbNavContent>
          <form class="card" ngForm #roleForm="ngForm" (ngSubmit)="submit(roleForm, role)">
            <div class="card-body">
              <div class="form-group row">
                <div class="col-sm-12">
                  <label for="name">Name</label>
                  <input type="text" class="form-control" id="name" name="name" [(ngModel)]="role.name" required>
                </div>
              </div>
            </div>

            <div class="card-body">
              <h5>Permissions</h5>
              <div class="row">
                <div [class]="sizing">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="can_admin" [(ngModel)]="role.can_admin"
                           id="can_admin">
                    <label class="form-check-label me-2" for="can_admin">Can Administrate</label>
                    <span class="fa fa-info-circle"
                          ngbTooltip="This should be reserved for those have can change district settings or are able to do uploads. Enabling this allows access to the district administration menu.">&nbsp;</span>
                  </div>
                </div>
                <div [class]="sizing">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="can_impersonate"
                           [(ngModel)]="role.can_impersonate" id="can_impersonate">
                    <label class="form-check-label me-2" for="can_impersonate">Can Impersonate</label>
                    <span class="fa fa-info-circle"
                          ngbTooltip="This allows a staff member to assume the identity of another staff member. This should be used strictly for troubleshooting.">&nbsp;</span>
                  </div>
                </div>
                <div [class]="sizing">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="modify_staff" [(ngModel)]="role.modify_staff"
                           id="modify_staff">
                    <label class="form-check-label me-2" for="modify_staff">Modify Staff</label>
                    <span class="fa fa-info-circle"
                          ngbTooltip="Can this user modify staff members, include granting roles?">&nbsp;</span>
                  </div>
                </div>
                <div [class]="sizing">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="create_student"
                           [(ngModel)]="role.create_student" id="create_student">
                    <label class="form-check-label me-2" for="create_student">Create Student</label>
                    <span class="fa fa-info-circle" ngbTooltip="Can this user modify student information?">&nbsp;</span>
                  </div>
                </div>
                <div [class]="sizing">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="delete_student"
                           [(ngModel)]="role.delete_student" id="delete_student">
                    <label class="form-check-label me-2" for="delete_student">Delete Student</label>
                    <span class="fa fa-info-circle" ngbTooltip="Can this user delete a student?">&nbsp;</span>
                  </div>
                </div>
                <div [class]="sizing">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="modify_district"
                           [(ngModel)]="role.modify_district" id="modify_district">
                    <label class="form-check-label me-2" for="modify_district">Modify District</label>
                    <span class="fa fa-info-circle"
                          ngbTooltip="Can this user modify the district? Such as name and domains, etc..">&nbsp;</span>
                  </div>
                </div>
                <div [class]="sizing">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="create_building"
                           [(ngModel)]="role.create_building" id="create_building">
                    <label class="form-check-label me-2" for="create_building">Create a building</label>
                    <span class="fa fa-info-circle" ngbTooltip="Can this user create a building?">&nbsp;</span>
                  </div>
                </div>
                <div [class]="sizing">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="modify_building"
                           [(ngModel)]="role.modify_building" id="modify_building">
                    <label class="form-check-label me-2" for="modify_building">Modify a building</label>
                    <span class="fa fa-info-circle" ngbTooltip="Can this user modify a building?">&nbsp;</span>
                  </div>
                </div>
                <div [class]="sizing">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="modify_building"
                           [(ngModel)]="role.delete_building" id="delete_building">
                    <label class="form-check-label me-2" for="delete_building">Delete a building</label>
                    <span class="fa fa-info-circle" ngbTooltip="Can this user delete a building?">&nbsp;</span>
                  </div>
                </div>
                <div [class]="sizing">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="create_roles" [(ngModel)]="role.create_roles"
                           id="create_roles">
                    <label class="form-check-label me-2" for="create_roles">Create a role</label>
                    <span class="fa fa-info-circle" ngbTooltip="Can this user create a role?">&nbsp;</span>
                  </div>
                </div>
                <div [class]="sizing">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="modify_roles" [(ngModel)]="role.modify_roles"
                           id="modify_roles">
                    <label class="form-check-label me-2" for="modify_roles">Modify a role</label>
                    <span class="fa fa-info-circle" ngbTooltip="Can this user modify a role?">&nbsp;</span>
                  </div>
                </div>
                <div [class]="sizing">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="delete_roles" [(ngModel)]="role.delete_roles"
                           id="delete_roles">
                    <label class="form-check-label me-2" for="delete_roles">Modify a role</label>
                    <span class="fa fa-info-circle" ngbTooltip="Can this user delete a role?">&nbsp;</span>
                  </div>
                </div>

                <div [class]="sizing">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="roam_buildings"
                           [(ngModel)]="role.roam_buildings" id="roam_buildings">
                    <label class="form-check-label me-2" for="roam_buildings">Roam Buildings</label>
                    <span class="fa fa-info-circle"
                          ngbTooltip="This allows a staff member to not be tied to any particular building, and have access to them all. This should be reserved for district administrators who need access to every student.">&nbsp;</span>
                  </div>
                </div>

                <div [class]="sizing">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="roam_students" [(ngModel)]="role.roam_students"
                           id="roam_students">
                    <label class="form-check-label me-2" for="roam_students">Roam Students</label>
                    <span class="fa fa-info-circle"
                          ngbTooltip="This allows a staff member to search for students that they are not directly connected to. Unless tied with Roam Buildings, the staff member can only search for students in their buildings.">&nbsp;</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="card-title">
                <h5 class="d-inline">Enabled Student Pages</h5>
                <span class="d-inline ms-2 fa fa-info-circle"
                      ngbTooltip="This will enable a module for a logged in staff member when viewing a student. Currently disabled during the transition phase">&nbsp;</span>
              </div>
              <div class="row">
                <div class="col">
                  <h6>Student</h6>
                  <div class="form-check" *ngFor="let module of studentTabs">
                    <input class="form-check-input" type="checkbox" [checked]="isCheckedModule(role, module.path)" (change)="toggleEnabledModule(roleForm, role, module.path)" [id]="module.name">
                    <label [for]="module.name" class="form-check-label">{{ module.name }}</label>
                  </div>
                </div>
                <div class="col">
                  <h6>Staff</h6>
                  <div class="form-check" *ngFor="let module of staffTabs">
                    <input class="form-check-input" type="checkbox" [checked]="isCheckedModule(role, module.path)" (change)="toggleEnabledModule(roleForm, role, module.path)" [id]="module.name">
                    <label [for]="module.name" class="form-check-label">{{ module.name }}</label>
                  </div>
                </div>
                <div class="col">
                  <h6>Meeting</h6>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [checked]="isCheckedModule(role, 'student/meetings')" (change)="toggleEnabledModule(form, role, 'student/meetings')" id="student/meetings">
                    <label for="student/meetings" class="form-check-label">Meetings</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="form-group row">
                <div class="col-sm-12 hstack">
                  <span class="ms-auto"></span>
                  <button type="button" class="btn btn-danger me-2" (click)="delete(role)">Delete</button>
                  <button type="button" class="btn btn-secondary me-2" (click)="cancel(roleForm)">Cancel</button>
                  <button type="submit" class="btn btn-primary" [disabled]="roleForm.valid && !roleForm.touched">Save
                  </button>
                </div>
              </div>
            </div>

          </form>
        </ng-template>
      </li>
    </ng-container>
    <li ngbNavItem="create">
      <a ngbNavLink (click)="addrole(nav)" roles="create_roles">Add role</a>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="ms-2 mt-2 flex-grow-1"></div>
</div>
